var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, state } from 'lit/decorators.js';
let RecentlyViewed = class RecentlyViewed extends LitElement {
    constructor() {
        super();
        this._recentlyViewedItems = [];
        this.nextSlide = (e) => {
            this.renderRoot.querySelector('.card-container').scrollBy(50, 0);
        };
        this.prevSlide = (e) => {
            this.renderRoot.querySelector('.card-container').scrollBy(-50, 0);
        };
        this.addCurrentProductToList = (parsedJson, limit = 4) => {
            const storedRecentItems = localStorage.getItem('recentlyViewed');
            let storedItemArray = [];
            if (storedRecentItems)
                storedItemArray = JSON.parse(storedRecentItems);
            let duplicate = false;
            let duplicateIndex = 0;
            storedItemArray.forEach((item, index) => {
                if (parsedJson.id == item.id) {
                    duplicate = true;
                    duplicateIndex = index;
                }
            });
            // If item is already in the list, move it to the front, else add it.
            if (duplicate)
                storedItemArray.unshift(storedItemArray.splice(duplicateIndex, 1)[0]);
            else
                storedItemArray.unshift(parsedJson);
            if (storedItemArray.length > limit)
                storedItemArray.length = limit;
            this._recentlyViewedItems = storedItemArray;
            localStorage.setItem('recentlyViewed', JSON.stringify(storedItemArray));
        };
        const toParse = this.querySelector('script');
        const parsed = JSON.parse(toParse.innerText);
        const limit = Number.parseInt(this.getAttribute('data-limit'));
        this.addCurrentProductToList(parsed, limit);
    }
    render() {
        return html `
      <h2 class="heading">Recently Viewed</h2>
      <div>
        <ul class="card-container grid">
          ${this._recentlyViewedItems.map((item) => html `
              <li class="card">
                <a class="card__link" href="/products/${item.handle}">
                  <img class="card__image" src="${item.featured_image}" />
                  <div class="card__title">${item.title}</div>
                  <s>${item.compare_at_price && "$"}${item.compare_at_price && item.compare_at_price / 100}</s>
                  <span>$${item.price / 100}</span>
                </a>
              </li>`)}
        </ul>
        <div class="slider-buttons no-js-hidden quick-add-hidden">
          <button @click="${this.prevSlide}" class="slider-button slider-button--prev" name="previous" aria-label="previous"><img loading="lazy" src="${this.getAttribute('data-prev-img')}"></button>
          <button @click="${this.nextSlide}" class="slider-button slider-button--next" name="next" aria-label="next"><img loading="lazy" src="${this.getAttribute('data-next-img')}"></button>
        </div>
      </div>
    `;
    }
};
RecentlyViewed.styles = [
    css `
      
          @media screen and (min-width: 990px) {
        .card {
            max-width: 24.5%;
            min-width: 24.5%
        }
          }
        @media screen and (max-width: 989px) {
        .card {
            max-width: 49%;
            min-width: 49%
        }
          }
        .card {
          scroll-snap-align: center;
        }
        .card .card__image {
            width: 100%;
          }
        .card .card__title {
            font-size: 1.3rem;
          }
        .card .card__link {
            color: inherit;
            text-decoration: none;
          }
        .card .card__link s {
              color: rgba(var(--color-foreground),.75);
              font-size: 1.3rem;
            }
        .card .card__link:hover .card__title {
            text-decoration: underline;
          }
        .card-container {
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          padding: 0px;
          overflow-x: auto;
          position: relative;
          scroll-behavior: smooth;
          -ms-scroll-snap-type: x mandatory;
              scroll-snap-type: x mandatory;
          list-style: none;
        }
        .grid {
          grid-column-gap: var(--grid-desktop-horizontal-spacing);
          -webkit-column-gap: var(--grid-desktop-horizontal-spacing);
             -moz-column-gap: var(--grid-desktop-horizontal-spacing);
                  column-gap: var(--grid-desktop-horizontal-spacing);
          grid-row-gap: var(--grid-desktop-vertical-spacing);
          row-gap: var(--grid-desktop-vertical-spacing)
        }
        .grid::-webkit-scrollbar {
            display: none;
          }
        .heading {
          font-weight: 400;
          text-align: center;
        }
        recently-viewed {
          position: relative;
        }
        .slider-buttons {
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-pack: justify;
              -ms-flex-pack: justify;
                  justify-content: space-between;
          position: absolute;
          width: 100%;
          top: 50%;
          -webkit-box-align: center;
              -ms-flex-align: center;
                  align-items: center;
          opacity: 0.8;
        }
        .slider-buttons img {
            border-radius: 3px;
          }
        .slider-button {
          position: absolute;
          padding: 0;
          border: none;
          cursor: pointer;
        }
        @media screen and (min-width: 990px) {
        .slider-button--prev {
            left: -1rem
        }
          }
        @media screen and (max-width: 989px) {
        .slider-button--prev {
            left: 1rem
        }
          }
        @media screen and (min-width: 990px) {
        .slider-button--next {
            right: -1rem
        }
          }
        @media screen and (max-width: 989px) {
        .slider-button--next {
            right: 1rem
        }
          }
      
    `
];
__decorate([
    state()
], RecentlyViewed.prototype, "_recentlyViewedItems", void 0);
RecentlyViewed = __decorate([
    customElement('recently-viewed')
], RecentlyViewed);
export { RecentlyViewed };
